<template>
  <div>
    <div class="product_body">
      <hotel-resource-left :productObj="productObj" @exclusiveAddYsP="exclusiveAddYsP" 
        @addReferBudget="addReferBudget" :btnName="butName" :btnName1="productObj.fromInquiryId?'':'抢'"></hotel-resource-left>
      <div :class="productObj.isOpen?'hidenDiv':'hidenDivTwo'">
        <div v-if="productObj.state!=6">
          <div class="hiden_item" v-for="(item,index) in productObj.stockListResults" :key="index">
            <div>
              <p>
                <el-checkbox style="margin-top:0.15rem" v-model="item.checkBox" @change="checkItem(item)">
                  <span>{{item.productNameCn}}</span>
                  <span v-if="item.productDesc!=''" style="font-size:0.12rem">({{item.productDesc}})</span>
                  <span v-if="item.mergerPurchase&&item.mergerPurchase!=''" class="label">不可拆分购买</span>
                </el-checkbox>
              </p>
            </div>
            <div style="margin-left:0.25rem">
              <p style="margin-top:0.08rem;">
                <i v-if="item.recommendation!=''" class="icon-aixin iconfont" style="color:#D81B43"></i>
                <label class="recommendation" v-if="item.recommendation!=''">{{item.recommendation}}</label>
                <label style="color:#D9D9D9;margin-right: 0.04rem;" v-if="item.recommendation!=''">|</label>
                <label class="recommendation" v-if="item.stockDesc!=''">{{item.stockDesc}}</label>
                <label class="recommendation" v-if="item.cityTaxPrice">城市税:{{item.cityTaxPrice}}{{item.priceList[0].currency}}/{{item.cityTaxCompany}}</label>
                <label style="color:#D9D9D9;margin-right: 0.04rem;" v-if="item.stockDesc!=''||item.cityTaxPrice">|</label>
                <label style="color:#155969;font-weight: bold;">
                  <label>{{item.cancelType==1?'不可取消':'有条件退'}} </label>
                  / 
                  <el-tooltip class="item" effect="dark" :content="item.isShareOption&&item.isShareOption==1?'下单后需资源方二次确认':'在option有效期内下订单，订单可自动确认'" placement="top">
                    <label>
                      <label v-if="item.isShareOption&&item.isShareOption==1">Shared </label>
                      <label>Option {{dateFormatYMD(item.optionTime,".")}} {{dateFormatHM(item.optionTime)}}</label>
                    </label>
                  </el-tooltip>
                </label>
              </p>
              <p style="margin-top: 0.06rem;" v-for="(p,i) in item.priceList" :key="i">        
                <label>
                  <span v-if="p.startDate!=''">{{p.startDate}}</span>
                  <label v-if="p.endDate!==''&&p.endDate!==p.startDate" style="color:#959090;margin-right:0.05rem;font-weight: bold;">至</label>
                  <span v-if="p.endDate!==''&&p.endDate!==p.startDate">{{p.endDate}}</span>
                </label>
                <label style="color:#E64A19;" >{{ butName=='加入报价'?'报价':'成本' }}   </label>
                <span>{{p.price}}{{p.currency}}/{{p.priceCompany}}/{{p.useTime}}</span>
                <template v-if="addPriceFlag">
                    <label style="color:#E64A19;">  报价 </label>
                    <span><el-input v-model="item.ratio" style="width: 50px;" size="mini" @change="changePrice(item)"></el-input></span>
                </template>
                <template v-if="productObj.fromInquiryId&&!addPriceFlag&&p.toCPrice!=0">
                    <label style="color:#E64A19;font-size: 14px;"> 报价 </label>
                    <span>{{p.toCPrice}}{{p.currency}}/{{p.priceCompany}}/{{p.useTime}}</span>
                </template>
                <span v-if="p.marketPrice!=''" style="font-size:0.12rem;">
                  （市价：{{p.marketPrice}}{{p.currency}}）
                </span>
                                <span>{{ p.number }}{{ p.priceCompany }}</span>
                                <span
                                    v-if="p.useTime&&p.useTime!=''&&item.state==0">{{ getBetweenDay([p.startDate, p.endDate]) }}{{ p.useTime }}</span>
                                <span
                                    v-if="p.useTime&&p.useTime!=''&&item.state!=0">{{ getBetweenDay([p.startDate, p.endDate]) + 1 }}{{ p.useTime }}</span>
                                <span style="margin-right:-4px;">{{ butName=='加入报价'?'':'成本' }}共&nbsp;</span>
                                <span v-if="item.state==0" class="orangeFont">
                  {{ Number((p.price * p.number * (getBetweenDay([p.startDate, p.endDate]))).toFixed(2)) }}{{ p.currency }}
                </span>
                                <span v-else class="orangeFont">
                  {{ p.price * p.number * (getBetweenDay([p.startDate, p.endDate]) + 1) }}{{ p.currency }}
                </span>
                <span v-if="p.toCPrice&&p.toCPrice>0"> <span> 报价共&nbsp;</span><span v-if="item.state==0" class="orangeFont">
                  {{ Number((p.toCPrice * p.number * (getBetweenDay([p.startDate, p.endDate]))).toFixed(2)) }}{{ p.currency }}
                </span>
                                <span v-else class="orangeFont">
                  {{ p.toCPrice * p.number * (getBetweenDay([p.startDate, p.endDate]) + 1) }}{{ p.currency }}
                </span>
                <span v-if="p.toCPrice&&p.toCPrice>0">
                     <span >利润</span>
                     <span v-if="item.state==0" class="orangeFont">
                    {{ Number(((p.toCPrice-p.price) * p.number * (getBetweenDay([p.startDate, p.endDate]))).toFixed(2)) }}{{ p.currency }}
                    </span>
                                    <span v-else class="orangeFont">
                    {{ (p.toCPrice-p.price) * p.number * (getBetweenDay([p.startDate, p.endDate]) + 1) }}{{ p.currency }}
                    </span>
                </span>
                </span>
                                <label v-if="p.remark!=''&&productObj.state!=4"
                                       style="font-size:0.12rem;color:#155969;">
                                    备注：{{ p.remark }}
                                </label>
                                <label v-if="p.remark!=''&&productObj.state==4"
                                       style="font-size:0.12rem;color:#155969;">
                                    菜品说明：{{ p.remark }}
                                </label>
                            </p>
                            <p style="margin-top: 0.06rem;">
                                <label class="productPriceButtom"
                                       @click="openPricePoliceDetail(item,'info1')">预定说明</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info2')">费用说明</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info3')">使用说明</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info4')">退改说明</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info5')">其他说明</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openSpecialNoteDialog(item)">特别说明</label>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-else class="hiden_item">
                    <p style="padding-top: 10px;font-size: 14px;padding-left: 21px;line-height: 25px;">
                        <label v-for="(item,index) in productObj.airBudgetRequests" :key="index">
                            <span v-if="item.trafficType!=''"
                                  style="color:rgb(230, 74, 25)">{{ item.trafficType }}</span>
                            <span>{{ item.startCityName }}-{{ item.endCityName }} 参考:{{ item.flightNumber }} </span>
                            <span style="color:#959090">出发</span>
                            <span
                                class="inlineword">{{ item.startAirport }} {{ dateFormat3(item.startDate, '.') }} {{ item.startTime }} {{ item.startTerminal }}</span>
                            <span style="color:#959090">抵达</span>
                            <span
                                class="inlineword">{{ item.endAirport }} {{ dateFormat3(item.endDate, '.') }} {{ item.endTime }} {{ item.endTerminal }}</span>
                            <span v-if="index!=productObj.airBudgetRequests.length-1" class="shuxian">|</span>
                        </label>
                    </p>
                    <div v-for="(item,index) in productObj.detailResponses" :key="index">
                        <div style="min-width: 80px;">
                            <p style="position: relative;top: -10px;margin-top:0px;">
                                <el-checkbox style="margin-top:15px">
                                    <span>{{ item.productRoomName }}</span>
                                    <span>{{ item.productDesc }}</span>
                                    <label style="color:#E64A19;font-size: 14px;"> 报价 </label>
                                    <span>
                    {{ item.detailDateResponces[0].price }}
                    {{ item.detailDateResponces[0].currency }}/{{ item.detailDateResponces[0].company }}
                                        <!-- <input v-if="source&&source==1" type="number" v-model="item.detailDateResponces[0].copyPrice" style="width:50px;border:1px solid #e5e5e5;"> -->
                    <span>{{ item.detailDateResponces[0].number }}{{ item.detailDateResponces[0].company }}</span>
                    <span style="margin-right:-4px;">共</span>
                    <span class="orangeFont">
                      {{ item.detailDateResponces[0].price * item.detailDateResponces[0].number }}{{ item.detailDateResponces[0].currency }}
                    </span>
                  </span>
                                </el-checkbox>
                            </p>
                            <p style="margin-top: 0px;margin-left: 21px;">
                                <label class="productPriceButtom"
                                       @click="openPricePoliceDetail(item,'info1')">退票说明</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info2')">改期说明</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info3')">航司备注</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info4')">航司积分</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info5')">签转说明</label>
                                <label class="productPriceButtom" style="margin-left:5px;"
                                       @click="openPricePoliceDetail(item,'info5')">行李额</label>
                            </p>
                        </div>
                    </div>
                    <p style="margin-top: 12px;margin-left: 21px;line-height: 20px;">
                        <span
                            style="font-size: 10px;color: #4F6D7D;margin-right:10px;">备注：{{ productObj.introduce }}</span>
                        <span class="shuxian" style="top: -1px;">|</span>
                        <span style="font-size: 10px;color: #4F6D7D;">
              Option {{ dateFormat3(productObj.detailResponses[0].optionDate, ".") }}
              {{ dateFormat4(productObj.detailResponses[0].optionDate) }}
            </span>
                        <span class="shuxian" style="top: -1px;">|</span>
                        <span v-for="(item,index) in productObj.airBudgetRequests" :key="index"
                              style="font-size: 10px;color: #4F6D7D;">
              <span v-if="item.remark!=''">{{ item.trafficType }}参考车次备注:{{ item.remark }}&nbsp;</span>
            </span>
                    </p>
                </div>
                <div class="buttonBox">
                    <i class="el-icon-caret-top" @click="productObj.isOpen=false"></i>
                </div>
            </div>
        </div>
<!--        <el-dialog :append-to-body='true' :visible.sync="dialogVisible" width="40%">-->
<!--            <stock-detail :productType="2" :stockDetailObj="stockDetailObj"></stock-detail>-->
<!--        </el-dialog>-->
        <policyDetailPopup ref="policyDetailPopup"></policyDetailPopup>
        <create-refer-product-dialog ref="createProduct" :keyStr="keyStr"></create-refer-product-dialog>
        <add-special-note-popup ref="addSpecialNotePopup" @save-success="handleSpecialNoteSaved"></add-special-note-popup>
        <el-dialog :append-to-body="true" :modal-append-to-body="true" :visible.sync="dialogLinkVisible" title="关联已加入产品"
                   width="30%">
            <el-table :data="tableData" style="width: 100%" tooltip-effect="dark"
                      @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="日期" width="120">
                    <template slot-scope="scope">{{ dateFormatYMD(scope.row.stayDate, "-") }}</template>
                </el-table-column>
                <el-table-column label="资源名称" prop="resourceNameCn" width="200"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLinkVisible = false">取 消</el-button>
        <el-button type="primary" @click="addLinkSure">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import Api from '@/components/Api/index.js'
import {refresh,getPlanInfo} from '../../js/function'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import stockDetail from '../../leftMoudle/dialog/stockDetail.vue'
import createReferProductDialog from "./addProductDialog/createReferProductDialog.vue"
import policyDetailPopup from "@/views/plan/rightPopup/dialog/policyDetailPopup.vue";
import AddSpecialNotePopup from "@/views/plan/rightPopup/dialog/addSpecialNotePopup.vue";
export default {
    components: {AddSpecialNotePopup, hotelResourceLeft, stockDetail, createReferProductDialog,policyDetailPopup},
    props: {
        productObj: {
            type: Object,
            default: {}
        },
        keyStr: {
            type: String,
            default: ''
        },
        butName: {
            type: String,
            default: '加入报价'
        }
    },
    data() {
        return {
            dialogVisible: false,
            stockDetailObj: {},
            dialogLinkVisible: false,
            tableData: [],
            linkBudgetIds: [],
            addPriceFlag:false,
        }
    },
    mounted() {
    },
    methods: {
        changePrice(item){
            this.$set(item,"checkBox",true)
        },
        handleSelectionChange(val) {
            this.linkBudgetIds = []
            val.forEach(e => {
                e.budgetIds.forEach(ee => {
                    this.linkBudgetIds.push(ee)
                })
            })
        },
        checkItem(item) {
            var arr = this.productObj.stockListResults.filter(e => e.mergerPurchase == item.mergerPurchase);
            arr.forEach(element => {
                this.$set(element, "checkBox", item.checkBox)
            });
        },
        addReferBudget() {
            var arr = []
            this.productObj.stockListResults.forEach(e => {
                if (e.checkBox) {
                    e.priceList.forEach(ee => {
                        var obj = JSON.parse(JSON.stringify(e))
                        this.$set(obj, 'startDate', ee.startDate)
                        this.$set(obj, 'endDate', ee.endDate)
                        this.$set(obj, 'checkNumber', ee.number)
                        this.$set(obj, 'optionDate', e.optionTime)
                        arr.push(obj)
                    })
                }
            })
            this.$refs.createProduct.beforeOpen(this.productObj, arr, {
                id: this.$store.state.budgetMainId,
                planId: this.$store.state.planId
            })
        },
        exclusiveAddYsP() {
            if(this.butName=='加价'){
                this.addPriceFlag = true;
                this.$set(this.productObj,"isOpen",true)
                this.butName = '保存并发送'
            }else if(this.butName=='保存并发送'){
                var planId = this.$store.state.planId
                var messageTip = '是否加入行程：'+planId+'?';
                var buttomName2 = "创建新的行程"
                if(!planId){
                    messageTip = '检测到左边没有行程信息，是否创建一个新的行程?';
                    buttomName2 = "取消"
                }
                this.$confirm(messageTip, '加入行程选择', {
                    confirmButtonText: '确认',
                    cancelButtonText: buttomName2,
                    type: 'warning'
                }).then(() => {
                    this.postAddBudgetInquiry(this.$store.state.planId,this.$store.state.budgetMainId)  
                }).catch(() => {
                    if(planId){
                        this.postAddBudgetInquiry(null,null)
                    }
                });
            }else if(this.butName=='加入报价'){
                this.$confirm('是直接加入行程轴还是关联已加入产品?', '加入行程选择', {
                    confirmButtonText: '直接加入行程轴',
                    cancelButtonText: '关联已加入产品',
                    type: 'warning'
                }).then(() => {
                    this.linkBudgetIds = []
                    this.postAddBudget(this.$store.state.planId,this.$store.state.budgetMainId)
                }).catch(() => {
                    this.dialogLinkVisible = true
                    new PlanApi('plan').linkBudgetList({
                        state: this.productObj.state,
                        budgetMainId: this.$store.state.budgetMainId
                    }).then(res => {
                        if (res.status == 200) {
                            this.tableData = res.data
                        } else {
                            this.$message({type: "error", message: res.statusText})
                        }
                    })
                });
            }else{
                new Api('plan').getInquiryPlan({inquiryId:this.productObj.fromInquiryId}).then(res => {
                if (res.status == 200) {
                    getPlanInfo(res.data.planId)
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
            }
        },
        getAddBudgetParam(planId,budgetMainId){
            var arr = []
            this.productObj.stockListResults.forEach(e => {
                if (e.checkBox) {
                    arr.push({
                        "stockId": e.stockId,
                        "ratio": e.ratio
                    })
                }
            })
            var obj = {
                budgetMainId: budgetMainId,
                planId: planId,
                state: this.productObj.state,
                startLinkId: this.productObj.cityId,
                startLinkName: this.productObj.cityNameCn,
                startLinkNameEn: this.productObj.cityName,
                linkType: 1,
                productType: 2,
                resourceId: this.productObj.id,
                resourceNameCn: this.productObj.nameCn,
                resourceNameEn: this.productObj.nameEn,
                inquiryId:this.productObj.fromInquiryId,
                key: this.keyStr,
                details: arr,
                budgetIds: this.linkBudgetIds
            }
            return obj;
        },
        postAddBudgetInquiry(planId,budgetMainId){
            var obj = this.getAddBudgetParam(planId,budgetMainId);
            new Api('plan').budgetAdd(obj).then(res => {
                if (res.status == 200) {
                    this.$message({type: "success", message: "添加成功"})
                    refresh(res.data, res.data.planId)
                    this.butName = '已加入行程'
                    this.addPriceFlag = false;
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        postAddBudget() {
            this.getAddBudgetParam();
            new PlanApi('plan').budgetAdd(obj).then(res => {
                if (res.status == 200) {
                    if (this.linkBudgetIds.length > 0) this.dialogLinkVisible = false
                    this.$message({type: "success", message: "添加成功"})
                    refresh(res.data, this.$store.state.planId, this.$store.state.budgetMainId)
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        openPricePoliceDetail(item) {
            // this.dialogVisible=true
            // new Api('resource').stockDetail({stockIds:[item.stockId],productType:2}).then(res => {
            //   if (res.status == 200) {
            //     this.stockDetailObj = res.data[0]
            //   }
            // })
            console.log(item,'skksksk')
            this.$refs.policyDetailPopup.openDialog(item.stockId,item)
        },
        addLinkSure() {
            if (this.linkBudgetIds.length > 0) {
                this.postAddBudget()
            } else {
                this.$message({type: "error", message: "请选勾选要关联的数据"})
            }
        },
        
        // 打开特别说明弹框
        openSpecialNoteDialog(item) {
            this.$refs.addSpecialNotePopup.openDialog(this.productObj.id,item.stockId)
        },
        
        // 处理特别说明保存成功
        handleSpecialNoteSaved(data) {
            console.log('特别说明保存成功', data)
            // 这里可以根据需要刷新数据或执行其他操作
        }
    }
}
</script>

<style lang="scss" scoped>
.product_body {
    background: #fff;
    border: 1px solid #f54402;
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
    margin: 0.1rem 0;
    padding: 0.1rem 0 0 0;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4);

    .hidenDivTwo {
        height: 0;
        overflow: hidden;
    }

    .hidenDiv {
        padding: 0 0.1rem;

        .hiden_item {
            margin-top: 0.1rem;

            .label {
                line-height: 0.24rem;
                border: 1px solid #5d76f4;
                color: #5d76f4;
                font-weight: bold;
                padding: 0.02rem 0.05rem;
                margin-left: 0.1rem;
                font-size: 0.12rem;
            }

            .shuxian {
                margin-right: 10px;
                color: #D9D9D9;
                position: relative;
                top: -2px;
            }

            .inlineword {
                display: inline;
                word-break: break-all;
            }

            .recommendation {
                color: #D81B43;
                font-weight: bold;
            }

            span {
                margin-right: 6px;
                font-size: 14px;
                color: #333;
                font-weight: bold;
            }

            .orangeFont {
                color: #da4e1a;
            }

            .productPriceButtom {
                background: #F2EDED;
                padding: 2px 4px 2px 4px;
                color: #E64A19;
            }
        }

        .buttonBox {
            display: flex;
            justify-content: flex-end;

            .el-icon-caret-top {
                font-size: 26px;
                cursor: pointer;
            }
        }
    }
}
</style>